import React from "react";

import { interestOptions } from "../../data";
import { CategoryContainer } from "../../components/CategoryContainer";
import { AutocompleteRHF } from "../../components/RHFWrappedComponents";

export function Interests() {
  return (
    <CategoryContainer title="Interests">
      <AutocompleteRHF
        name="academicInfo.interests"
        selectLabel="Your Interests"
        options={interestOptions}
        multiple={true}
      />
    </CategoryContainer>
  );
}
